export enum Flipper {
  webhookConfiguration = 'rt_webhook_configuration',
}
